import { isRegexMatch } from 'helpers/core';
import { defineMessages } from 'react-intl';
import { isPossiblePhoneNumber } from 'react-phone-number-input';

import { EMAIL_REGEX } from 'constants/logic';

const messages = defineMessages({
  requiredField: {
    id: 'instructor-form.errors.required',
    defaultMessage: 'This field is required',
  },
  invalidEmail: {
    id: 'instructor-form.errors.invalid-email',
    defaultMessage: 'Please enter a valid email address',
  },
  invalidPhone: {
    id: 'instructor-form.errors.invalid-phone',
    defaultMessage: 'Please enter a valid phone number',
  },
});

export const syncValidator = values => {
  const { firstName, email, phone } = values;

  const errors = {};
  if (!firstName) {
    errors.firstName = messages.requiredField;
  }

  if (email && !isRegexMatch(email, EMAIL_REGEX)) {
    errors.email = messages.invalidEmail;
  }

  if (phone && !isPossiblePhoneNumber(phone)) {
    errors.phone = messages.invalidPhone;
  }

  return errors;
};

export const SOCIAL_HANDLES = {
  socialHandles: [
    {
      service: 'instagram',
      userName: '',
    },
  ],
};
